import { render } from "./StConfirm.vue?vue&type=template&id=0d597c54"
import script from "./StConfirm.vue?vue&type=script&lang=js"
export * from "./StConfirm.vue?vue&type=script&lang=js"

import "./StConfirm.vue?vue&type=style&index=0&id=0d597c54&lang=scss"

import exportComponent from "/Users/ondaa/workspace/schoolmom_qna_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__